// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AuditOutlinedSvg from "@fishx/icons-svg/es/asn/AuditOutlined";
import FishxIcon from '../components/FishxIcon';

var AuditOutlined = function AuditOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AuditOutlinedSvg
  }));
};

AuditOutlined.displayName = 'AuditOutlined';
export default React.forwardRef(AuditOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AuditOutlined.js
// module id = 2040
// module chunks = 0